markReady